module.exports = __webpack_public_path__ + "static/media/heart-broken.99051071.svg";